import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface FilterOption {
  label: string;
  value: string;
}

interface PageFiltersProps {
  search?: string;
  searchPlaceholder?: string;
  onSearchChange?: (value: string) => void;
  filters?: {
    id: string;
    label: string;
    value: string;
    options: FilterOption[];
    onChange: (value: string) => void;
  }[];
  children?: React.ReactNode;
}

const PageFilters: React.FC<PageFiltersProps> = ({
  search,
  searchPlaceholder = 'Search…',
  onSearchChange,
  filters = [],
  children,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 1.5,
      mb: 2.5,
      alignItems: 'center',
    }}
  >
    {onSearchChange && (
      <TextField
        size="small"
        value={search || ''}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={searchPlaceholder}
        sx={{ minWidth: 240, flex: '1 1 220px' }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" color="action" />
            </InputAdornment>
          ),
        }}
      />
    )}
    {filters.map((filter) => (
      <FormControl key={filter.id} size="small" sx={{ minWidth: 160 }}>
        <InputLabel>{filter.label}</InputLabel>
        <Select
          label={filter.label}
          value={filter.value}
          onChange={(e) => filter.onChange(e.target.value)}
        >
          {filter.options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ))}
    {children}
  </Box>
);

export default PageFilters;
